import { api } from "@/lib/api";

// Module-level cache so the clock widget and the manual entry form can share
// one fetch per session. The list rarely changes mid-session — we invalidate
// after a successful entry create / clock stop so a brand-new activity shows
// up next time without a manual reload.
let _cached = null;
let _inflight = null;

async function fetchRecentActivities() {
  if (_cached) return _cached;
  if (_inflight) return _inflight;
  _inflight = api
    .get("/entries/recent-activities")
    .then(({ data }) => {
      _cached = data?.activities || [];
      return _cached;
    })
    .catch(() => {
      _cached = [];
      return [];
    })
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export function clearRecentActivitiesCache() {
  _cached = null;
  _inflight = null;
}

export function getRecentActivities() {
  return fetchRecentActivities();
}
